import { render } from "./PickupPdf.vue?vue&type=template&id=10fd93a6&scoped=true"
import script from "./PickupPdf.vue?vue&type=script&lang=js"
export * from "./PickupPdf.vue?vue&type=script&lang=js"

import "./PickupPdf.vue?vue&type=style&index=0&id=10fd93a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10fd93a6"]])

export default __exports__